// Texty toolbaru výpisu a mobilného stránkovania — slovenské dvojča listingTools.js.
export default {
  defaultSort: 'Odporúčame',
  range: (start, end, total) => start + '–' + end + ' z ' + total,
  page: (from, pages) => 'Strana ' + from + ' z ' + pages,
  pages: (from, to, pages) => 'Strany ' + from + '–' + to + ' z ' + pages,
  prevPage: 'Predchádzajúca strana',
  nextPage: 'Ďalšia strana',
};
